import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import HerePtRoutes from './HerePtRoutes';
import LeafletPtRoutes from './LeafletPtRoutes';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: LeafletPtRoutes,
  [TILE_LIBRARY_TYPES.JSLA]: HerePtRoutes,
};
